/**
 * Do not edit directly, this file was auto-generated.
 */

export default {
  color: {
    primary: {
      1: {
        key: "{color.primary.1}",
        $value: {
          light: "(palette.runtime.accent.light.1)",
          dark: "(palette.runtime.accent.dark.1)",
        },
      },
      2: {
        key: "{color.primary.2}",
        $value: {
          light: "(palette.runtime.accent.light.2)",
          dark: "(palette.runtime.accent.dark.2)",
        },
      },
      3: {
        key: "{color.primary.3}",
        $value: {
          light: "(palette.runtime.accent.light.3)",
          dark: "(palette.runtime.accent.dark.3)",
        },
      },
      4: {
        key: "{color.primary.4}",
        $value: {
          light: "(palette.runtime.accent.light.4)",
          dark: "(palette.runtime.accent.dark.4)",
        },
      },
      5: {
        key: "{color.primary.5}",
        $value: {
          light: "(palette.runtime.accent.light.5)",
          dark: "(palette.runtime.accent.dark.5)",
        },
      },
      6: {
        key: "{color.primary.6}",
        $value: {
          light: "(palette.runtime.accent.light.6)",
          dark: "(palette.runtime.accent.dark.6)",
        },
      },
      7: {
        key: "{color.primary.7}",
        $value: {
          light: "(palette.runtime.accent.light.7)",
          dark: "(palette.runtime.accent.dark.7)",
        },
      },
      8: {
        key: "{color.primary.8}",
        $value: {
          light: "(palette.runtime.accent.light.8)",
          dark: "(palette.runtime.accent.dark.8)",
        },
      },
      9: {
        key: "{color.primary.9}",
        $value: {
          light: "(palette.runtime.accent.light.9)",
          dark: "(palette.runtime.accent.dark.9)",
        },
      },
      10: {
        key: "{color.primary.10}",
        $value: {
          light: "(palette.runtime.accent.light.10)",
          dark: "(palette.runtime.accent.dark.10)",
        },
      },
      11: {
        key: "{color.primary.11}",
        $value: {
          light: "(palette.runtime.accent.light.11)",
          dark: "(palette.runtime.accent.dark.11)",
        },
      },
      12: {
        key: "{color.primary.12}",
        $value: {
          light: "(palette.runtime.accent.light.12)",
          dark: "(palette.runtime.accent.dark.12)",
        },
      },
      50: {
        key: "{color.primary.50}",
        $value: {
          light: "(palette.runtime.accent.light.3)",
          dark: "(palette.runtime.accent.light.3)",
        },
      },
      100: {
        key: "{color.primary.100}",
        $value: {
          light: "(palette.runtime.accent.light.5)",
          dark: "(palette.runtime.accent.light.5)",
        },
      },
      200: {
        key: "{color.primary.200}",
        $value: {
          light: "(palette.runtime.accent.light.6)",
          dark: "(palette.runtime.accent.light.6)",
        },
      },
      300: {
        key: "{color.primary.300}",
        $value: {
          light: "(palette.runtime.accent.light.7)",
          dark: "(palette.runtime.accent.light.7)",
        },
      },
      400: {
        key: "{color.primary.400}",
        $value: {
          light: "(palette.runtime.accent.dark.11)",
          dark: "(palette.runtime.accent.dark.11)",
        },
      },
      500: {
        key: "{color.primary.500}",
        $value: {
          light: "(palette.runtime.accent.light.9)",
          dark: "(palette.runtime.accent.light.9)",
        },
      },
      600: {
        key: "{color.primary.600}",
        $value: {
          light: "(palette.runtime.accent.light.11)",
          dark: "(palette.runtime.accent.light.11)",
        },
      },
      700: {
        key: "{color.primary.700}",
        $value: {
          light: "(palette.runtime.accent.dark.6)",
          dark: "(palette.runtime.accent.dark.6)",
        },
      },
      800: {
        key: "{color.primary.800}",
        $value: {
          light: "(palette.runtime.accent.dark.5)",
          dark: "(palette.runtime.accent.dark.5)",
        },
      },
      900: {
        key: "{color.primary.900}",
        $value: {
          light: "(palette.runtime.accent.dark.4)",
          dark: "(palette.runtime.accent.dark.4)",
        },
      },
      950: {
        key: "{color.primary.950}",
        $value: {
          light: "(palette.runtime.accent.dark.3)",
          dark: "(palette.runtime.accent.dark.3)",
        },
      },
      lightest: {
        key: "{color.primary.lightest}",
        $value: {
          light: "(palette.runtime.accent.light.4)",
          dark: "(palette.runtime.accent.light.4)",
        },
      },
      light: {
        key: "{color.primary.light}",
        $value: {
          light: "(palette.runtime.accent.dark.11)",
          dark: "(palette.runtime.accent.dark.11)",
        },
      },
      main: {
        key: "{color.primary.main}",
        $value: {
          light: "(palette.runtime.accent.light.9)",
          dark: "(palette.runtime.accent.dark.9)",
        },
      },
      dark: {
        key: "{color.primary.dark}",
        $value: {
          light: "(palette.runtime.accent.light.11)",
          dark: "(palette.runtime.accent.light.11)",
        },
      },
      darkest: {
        key: "{color.primary.darkest}",
        $value: {
          light: "(palette.runtime.accent.dark.6)",
          dark: "(palette.runtime.accent.dark.6)",
        },
      },
      contrast: {
        key: "{color.primary.contrast}",
        $value: {
          light: "(palette.runtime.accent.light.contrast)",
          dark: "(palette.runtime.accent.dark.contrast)",
        },
      },
      borderRegular: {
        key: "{color.primary.borderRegular}",
        $value: {
          light: "(palette.runtime.accent.light.a7)",
          dark: "(palette.runtime.accent.dark.a7)",
        },
      },
      track: {
        key: "{color.primary.track}",
        $value: {
          light: "(palette.runtime.accent.light.9)",
          dark: "(palette.runtime.accent.dark.9)",
        },
      },
      a1: {
        key: "{color.primary.a1}",
        $value: {
          light: "(palette.runtime.accent.light.a1)",
          dark: "(palette.runtime.accent.dark.a1)",
        },
      },
      a2: {
        key: "{color.primary.a2}",
        $value: {
          light: "(palette.runtime.accent.light.a2)",
          dark: "(palette.runtime.accent.dark.a2)",
        },
      },
      a3: {
        key: "{color.primary.a3}",
        $value: {
          light: "(palette.runtime.accent.light.a3)",
          dark: "(palette.runtime.accent.dark.a3)",
        },
      },
      a4: {
        key: "{color.primary.a4}",
        $value: {
          light: "(palette.runtime.accent.light.a4)",
          dark: "(palette.runtime.accent.dark.a4)",
        },
      },
      a5: {
        key: "{color.primary.a5}",
        $value: {
          light: "(palette.runtime.accent.light.a5)",
          dark: "(palette.runtime.accent.dark.a5)",
        },
      },
      a6: {
        key: "{color.primary.a6}",
        $value: {
          light: "(palette.runtime.accent.light.a6)",
          dark: "(palette.runtime.accent.dark.a6)",
        },
      },
      a7: {
        key: "{color.primary.a7}",
        $value: {
          light: "(palette.runtime.accent.light.a7)",
          dark: "(palette.runtime.accent.dark.a7)",
        },
      },
      a8: {
        key: "{color.primary.a8}",
        $value: {
          light: "(palette.runtime.accent.light.a8)",
          dark: "(palette.runtime.accent.dark.a8)",
        },
      },
      a9: {
        key: "{color.primary.a9}",
        $value: {
          light: "(palette.runtime.accent.light.a9)",
          dark: "(palette.runtime.accent.dark.a9)",
        },
      },
      a10: {
        key: "{color.primary.a10}",
        $value: {
          light: "(palette.runtime.accent.light.a10)",
          dark: "(palette.runtime.accent.dark.a10)",
        },
      },
      a11: {
        key: "{color.primary.a11}",
        $value: {
          light: "(palette.runtime.accent.light.a11)",
          dark: "(palette.runtime.accent.dark.a11)",
        },
      },
      a12: {
        key: "{color.primary.a12}",
        $value: {
          light: "(palette.runtime.accent.light.a12)",
          dark: "(palette.runtime.accent.dark.a12)",
        },
      },
      indicator: {
        key: "{color.primary.indicator}",
        $value: {
          light: "(palette.runtime.accent.light.9)",
          dark: "(palette.runtime.accent.dark.9)",
        },
      },
      surface: {
        key: "{color.primary.surface}",
        $value: {
          light: "(palette.runtime.accent.light.surface)",
          dark: "(palette.runtime.accent.dark.surface)",
        },
      },
      borderSubtle: {
        key: "{color.primary.borderSubtle}",
        $value: {
          light: "(palette.runtime.accent.light.a6)",
          dark: "(palette.runtime.accent.dark.a6)",
        },
      },
      backgroundSoft: {
        key: "{color.primary.backgroundSoft}",
        $value: {
          light: "(palette.runtime.accent.light.a3)",
          dark: "(palette.runtime.accent.dark.a3)",
        },
      },
      text: {
        key: "{color.primary.text}",
        $value: {
          light: "(palette.runtime.accent.light.a11)",
          dark: "(palette.runtime.accent.dark.a11)",
        },
      },
      solid: {
        key: "{color.primary.solid}",
        $value: {
          light: "(palette.runtime.accent.light.9)",
          dark: "(palette.runtime.accent.dark.9)",
        },
      },
      solidHover: {
        key: "{color.primary.solidHover}",
        $value: {
          light: "(palette.runtime.accent.light.10)",
          dark: "(palette.runtime.accent.dark.10)",
        },
      },
      highContrast: {
        key: "{color.primary.highContrast}",
        $value: {
          light: "(palette.runtime.accent.light.a12)",
          dark: "(palette.runtime.accent.dark.a12)",
        },
      },
      backgroundSubtle: {
        key: "{color.primary.backgroundSubtle}",
        $value: {
          light: "(palette.runtime.accent.light.a2)",
          dark: "(palette.runtime.accent.dark.a2)",
        },
      },
      backgroundSoftHover: {
        key: "{color.primary.backgroundSoftHover}",
        $value: {
          light: "(palette.runtime.accent.light.a4)",
          dark: "(palette.runtime.accent.dark.a4)",
        },
      },
      backgroundSoftActive: {
        key: "{color.primary.backgroundSoftActive}",
        $value: {
          light: "(palette.runtime.accent.light.a5)",
          dark: "(palette.runtime.accent.dark.a5)",
        },
      },
      borderStrong: {
        key: "{color.primary.borderStrong}",
        $value: {
          light: "(palette.runtime.accent.light.a8)",
          dark: "(palette.runtime.accent.dark.a8)",
        },
      },
      backgroundSubtlest: {
        key: "{color.primary.backgroundSubtlest}",
        $value: {
          light: "(palette.runtime.accent.light.a1)",
          dark: "(palette.runtime.accent.dark.a1)",
        },
      },
      onHighContrast: {
        key: "{color.primary.onHighContrast}",
        $value: {
          light: "(palette.runtime.accent.dark.12)",
          dark: "(palette.runtime.accent.light.12)",
        },
      },
      textAccessible: {
        key: "{color.primary.textAccessible}",
        $value: {
          light: "(palette.runtime.accent.light.a11)",
          dark: "(palette.runtime.accent.dark.a11)",
        },
      },
    },
    secondary: {
      1: {
        key: "{color.secondary.1}",
        $value: {
          light: "(palette.runtime.gray.light.1)",
          dark: "(palette.runtime.gray.dark.1)",
        },
      },
      2: {
        key: "{color.secondary.2}",
        $value: {
          light: "(palette.runtime.gray.light.2)",
          dark: "(palette.runtime.gray.dark.2)",
        },
      },
      3: {
        key: "{color.secondary.3}",
        $value: {
          light: "(palette.runtime.gray.light.3)",
          dark: "(palette.runtime.gray.dark.3)",
        },
      },
      4: {
        key: "{color.secondary.4}",
        $value: {
          light: "(palette.runtime.gray.light.4)",
          dark: "(palette.runtime.gray.dark.4)",
        },
      },
      5: {
        key: "{color.secondary.5}",
        $value: {
          light: "(palette.runtime.gray.light.5)",
          dark: "(palette.runtime.gray.dark.5)",
        },
      },
      6: {
        key: "{color.secondary.6}",
        $value: {
          light: "(palette.runtime.gray.light.6)",
          dark: "(palette.runtime.gray.dark.6)",
        },
      },
      7: {
        key: "{color.secondary.7}",
        $value: {
          light: "(palette.runtime.gray.light.7)",
          dark: "(palette.runtime.gray.dark.7)",
        },
      },
      8: {
        key: "{color.secondary.8}",
        $value: {
          light: "(palette.runtime.gray.light.8)",
          dark: "(palette.runtime.gray.dark.8)",
        },
      },
      9: {
        key: "{color.secondary.9}",
        $value: {
          light: "(palette.runtime.gray.light.9)",
          dark: "(palette.runtime.gray.dark.9)",
        },
      },
      10: {
        key: "{color.secondary.10}",
        $value: {
          light: "(palette.runtime.gray.light.10)",
          dark: "(palette.runtime.gray.dark.10)",
        },
      },
      11: {
        key: "{color.secondary.11}",
        $value: {
          light: "(palette.runtime.gray.light.11)",
          dark: "(palette.runtime.gray.dark.11)",
        },
      },
      12: {
        key: "{color.secondary.12}",
        $value: {
          light: "(palette.runtime.gray.light.12)",
          dark: "(palette.runtime.gray.dark.12)",
        },
      },
      50: {
        key: "{color.secondary.50}",
        $value: {
          light: "(palette.runtime.gray.light.2)",
          dark: "(palette.runtime.gray.light.2)",
        },
      },
      100: {
        key: "{color.secondary.100}",
        $value: {
          light: "(palette.runtime.gray.light.3)",
          dark: "(palette.runtime.gray.light.3)",
        },
      },
      200: {
        key: "{color.secondary.200}",
        $value: {
          light: "(palette.runtime.gray.light.5)",
          dark: "(palette.runtime.gray.light.5)",
        },
      },
      300: {
        key: "{color.secondary.300}",
        $value: {
          light: "(palette.runtime.gray.light.8)",
          dark: "(palette.runtime.gray.light.8)",
        },
      },
      400: {
        key: "{color.secondary.400}",
        $value: {
          light: "(palette.runtime.gray.light.9)",
          dark: "(palette.runtime.gray.light.9)",
        },
      },
      500: {
        key: "{color.secondary.500}",
        $value: {
          light: "(palette.runtime.gray.light.11)",
          dark: "(palette.runtime.gray.light.11)",
        },
      },
      600: {
        key: "{color.secondary.600}",
        $value: {
          light: "(palette.runtime.gray.dark.7)",
          dark: "(palette.runtime.gray.dark.7)",
        },
      },
      700: {
        key: "{color.secondary.700}",
        $value: {
          light: "(palette.runtime.gray.dark.6)",
          dark: "(palette.runtime.gray.dark.6)",
        },
      },
      800: {
        key: "{color.secondary.800}",
        $value: {
          light: "(palette.runtime.gray.dark.5)",
          dark: "(palette.runtime.gray.dark.5)",
        },
      },
      900: {
        key: "{color.secondary.900}",
        $value: {
          light: "(palette.runtime.gray.dark.4)",
          dark: "(palette.runtime.gray.dark.4)",
        },
      },
      950: {
        key: "{color.secondary.950}",
        $value: {
          light: "(palette.runtime.gray.dark.2)",
          dark: "(palette.runtime.gray.dark.2)",
        },
      },
      lightest: {
        key: "{color.secondary.lightest}",
        $value: {
          light: "(palette.runtime.gray.light.4)",
          dark: "(palette.runtime.gray.light.3)",
        },
      },
      light: {
        key: "{color.secondary.light}",
        $value: {
          light: "(palette.runtime.gray.light.8)",
          dark: "(palette.runtime.gray.light.7)",
        },
      },
      main: {
        key: "{color.secondary.main}",
        $value: {
          light: "(palette.runtime.gray.light.11)",
          dark: "(palette.runtime.gray.dark.11)",
        },
      },
      dark: {
        key: "{color.secondary.dark}",
        $value: {
          light: "(palette.runtime.gray.dark.7)",
          dark: "(palette.runtime.gray.dark.8)",
        },
      },
      darkest: {
        key: "{color.secondary.darkest}",
        $value: {
          light: "(palette.runtime.gray.dark.5)",
          dark: "(palette.runtime.gray.dark.6)",
        },
      },
      contrast: {
        key: "{color.secondary.contrast}",
        $value: {
          light: "(palette.runtime.gray.light.contrast)",
          dark: "(palette.runtime.gray.dark.contrast)",
        },
      },
      borderRegular: {
        key: "{color.secondary.borderRegular}",
        $value: {
          light: "(palette.runtime.gray.light.a7)",
          dark: "(palette.runtime.gray.dark.a7)",
        },
      },
      track: {
        key: "{color.secondary.track}",
        $value: {
          light: "(palette.runtime.gray.light.9)",
          dark: "(palette.runtime.gray.dark.9)",
        },
      },
      a12: {
        key: "{color.secondary.a12}",
        $value: {
          light: "(palette.runtime.gray.light.a12)",
          dark: "(palette.runtime.gray.dark.a11)",
        },
      },
      a10: {
        key: "{color.secondary.a10}",
        $value: {
          light: "(palette.runtime.gray.light.a10)",
          dark: "(palette.runtime.gray.dark.a10)",
        },
      },
      a8: {
        key: "{color.secondary.a8}",
        $value: {
          light: "(palette.runtime.gray.light.a8)",
          dark: "(palette.runtime.gray.dark.a8)",
        },
      },
      a7: {
        key: "{color.secondary.a7}",
        $value: {
          light: "(palette.runtime.gray.light.a7)",
          dark: "(palette.runtime.gray.dark.a7)",
        },
      },
      a5: {
        key: "{color.secondary.a5}",
        $value: {
          light: "(palette.runtime.gray.light.a5)",
          dark: "(palette.runtime.gray.dark.a5)",
        },
      },
      a2: {
        key: "{color.secondary.a2}",
        $value: {
          light: "(palette.runtime.gray.light.a2)",
          dark: "(palette.runtime.gray.dark.a2)",
        },
      },
      a3: {
        key: "{color.secondary.a3}",
        $value: {
          light: "(palette.runtime.gray.light.a3)",
          dark: "(palette.runtime.gray.dark.a3)",
        },
      },
      a1: {
        key: "{color.secondary.a1}",
        $value: {
          light: "(palette.runtime.gray.light.a1)",
          dark: "(palette.runtime.gray.dark.a1)",
        },
      },
      a6: {
        key: "{color.secondary.a6}",
        $value: {
          light: "(palette.runtime.gray.light.a6)",
          dark: "(palette.runtime.gray.dark.a6)",
        },
      },
      a11: {
        key: "{color.secondary.a11}",
        $value: {
          light: "(palette.runtime.gray.light.a11)",
          dark: "(palette.runtime.gray.dark.a11)",
        },
      },
      a4: {
        key: "{color.secondary.a4}",
        $value: {
          light: "(palette.runtime.gray.light.a4)",
          dark: "(palette.runtime.gray.dark.a4)",
        },
      },
      a9: {
        key: "{color.secondary.a9}",
        $value: {
          light: "(palette.runtime.gray.light.a9)",
          dark: "(palette.runtime.gray.dark.a9)",
        },
      },
      indicator: {
        key: "{color.secondary.indicator}",
        $value: {
          light: "(palette.runtime.gray.light.9)",
          dark: "(palette.runtime.gray.dark.9)",
        },
      },
      surface: {
        key: "{color.secondary.surface}",
        $value: {
          light: "(palette.runtime.gray.light.surface)",
          dark: "(palette.runtime.gray.dark.surface)",
        },
      },
      backgroundSubtle: {
        key: "{color.secondary.backgroundSubtle}",
        $value: {
          light: "(palette.runtime.gray.light.a2)",
          dark: "(palette.runtime.gray.dark.a2)",
        },
      },
      highContrast: {
        key: "{color.secondary.highContrast}",
        $value: {
          light: "(palette.runtime.gray.light.a12)",
          dark: "(palette.runtime.gray.dark.a12)",
        },
      },
      text: {
        key: "{color.secondary.text}",
        $value: {
          light: "(palette.runtime.gray.light.a11)",
          dark: "(palette.runtime.gray.dark.a11)",
        },
      },
      solid: {
        key: "{color.secondary.solid}",
        $value: {
          light: "(palette.runtime.gray.light.9)",
          dark: "(palette.runtime.gray.dark.9)",
        },
      },
      backgroundSoft: {
        key: "{color.secondary.backgroundSoft}",
        $value: {
          light: "(palette.runtime.gray.light.a3)",
          dark: "(palette.runtime.gray.dark.a3)",
        },
      },
      solidHover: {
        key: "{color.secondary.solidHover}",
        $value: {
          light: "(palette.runtime.gray.light.10)",
          dark: "(palette.runtime.gray.dark.10)",
        },
      },
      borderSubtle: {
        key: "{color.secondary.borderSubtle}",
        $value: {
          light: "(palette.runtime.gray.light.a6)",
          dark: "(palette.runtime.gray.dark.a6)",
        },
      },
      backgroundSubtlest: {
        key: "{color.secondary.backgroundSubtlest}",
        $value: {
          light: "(palette.runtime.gray.light.a1)",
          dark: "(palette.runtime.gray.dark.a1)",
        },
      },
      backgroundSoftHover: {
        key: "{color.secondary.backgroundSoftHover}",
        $value: {
          light: "(palette.runtime.gray.light.a4)",
          dark: "(palette.runtime.gray.dark.a4)",
        },
      },
      backgroundSoftActive: {
        key: "{color.secondary.backgroundSoftActive}",
        $value: {
          light: "(palette.runtime.gray.light.a5)",
          dark: "(palette.runtime.gray.dark.a5)",
        },
      },
      borderStrong: {
        key: "{color.secondary.borderStrong}",
        $value: {
          light: "(palette.runtime.gray.light.a8)",
          dark: "(palette.runtime.gray.dark.a8)",
        },
      },
      onHighContrast: {
        key: "{color.secondary.onHighContrast}",
        $value: {
          light: "(palette.runtime.gray.dark.12)",
          dark: "(palette.runtime.gray.light.12)",
        },
      },
      textAccessible: {
        key: "{color.secondary.textAccessible}",
        $value: {
          light: "(palette.runtime.gray.light.a11)",
          dark: "(palette.runtime.gray.dark.a11)",
        },
      },
    },
    info: {
      1: {
        key: "{color.info.1}",
        $value: {
          light: "(palette.runtime.gray.light.1)",
          dark: "(palette.runtime.gray.dark.1)",
        },
      },
      2: {
        key: "{color.info.2}",
        $value: {
          light: "(palette.runtime.gray.light.2)",
          dark: "(palette.runtime.gray.dark.2)",
        },
      },
      3: {
        key: "{color.info.3}",
        $value: {
          light: "(palette.runtime.gray.light.3)",
          dark: "(palette.runtime.gray.dark.3)",
        },
      },
      4: {
        key: "{color.info.4}",
        $value: {
          light: "(palette.runtime.gray.light.4)",
          dark: "(palette.runtime.gray.dark.4)",
        },
      },
      5: {
        key: "{color.info.5}",
        $value: {
          light: "(palette.runtime.gray.light.5)",
          dark: "(palette.runtime.gray.dark.5)",
        },
      },
      6: {
        key: "{color.info.6}",
        $value: {
          light: "(palette.runtime.gray.light.6)",
          dark: "(palette.runtime.gray.dark.6)",
        },
      },
      7: {
        key: "{color.info.7}",
        $value: {
          light: "(palette.runtime.gray.light.7)",
          dark: "(palette.runtime.gray.dark.7)",
        },
      },
      8: {
        key: "{color.info.8}",
        $value: {
          light: "(palette.runtime.gray.light.8)",
          dark: "(palette.runtime.gray.dark.8)",
        },
      },
      9: {
        key: "{color.info.9}",
        $value: {
          light: "(palette.runtime.gray.light.9)",
          dark: "(palette.runtime.gray.dark.9)",
        },
      },
      10: {
        key: "{color.info.10}",
        $value: {
          light: "(palette.runtime.gray.light.10)",
          dark: "(palette.runtime.gray.dark.10)",
        },
      },
      11: {
        key: "{color.info.11}",
        $value: {
          light: "(palette.runtime.gray.light.11)",
          dark: "(palette.runtime.gray.dark.11)",
        },
      },
      12: {
        key: "{color.info.12}",
        $value: {
          light: "(palette.runtime.gray.light.12)",
          dark: "(palette.runtime.gray.dark.12)",
        },
      },
      50: {
        key: "{color.info.50}",
        $value: {
          light: "(palette.runtime.gray.light.2)",
          dark: "(palette.runtime.gray.light.2)",
        },
      },
      100: {
        key: "{color.info.100}",
        $value: {
          light: "(palette.runtime.gray.light.3)",
          dark: "(palette.runtime.gray.light.3)",
        },
      },
      200: {
        key: "{color.info.200}",
        $value: {
          light: "(palette.runtime.gray.light.5)",
          dark: "(palette.runtime.gray.light.5)",
        },
      },
      300: {
        key: "{color.info.300}",
        $value: {
          light: "(palette.runtime.gray.light.8)",
          dark: "(palette.runtime.gray.light.8)",
        },
      },
      400: {
        key: "{color.info.400}",
        $value: {
          light: "(palette.runtime.gray.light.9)",
          dark: "(palette.runtime.gray.light.9)",
        },
      },
      500: {
        key: "{color.info.500}",
        $value: {
          light: "(palette.runtime.gray.light.11)",
          dark: "(palette.runtime.gray.light.11)",
        },
      },
      600: {
        key: "{color.info.600}",
        $value: {
          light: "(palette.runtime.gray.dark.7)",
          dark: "(palette.runtime.gray.dark.7)",
        },
      },
      700: {
        key: "{color.info.700}",
        $value: {
          light: "(palette.runtime.gray.dark.6)",
          dark: "(palette.runtime.gray.dark.6)",
        },
      },
      800: {
        key: "{color.info.800}",
        $value: {
          light: "(palette.runtime.gray.dark.5)",
          dark: "(palette.runtime.gray.dark.5)",
        },
      },
      900: {
        key: "{color.info.900}",
        $value: {
          light: "(palette.runtime.gray.dark.4)",
          dark: "(palette.runtime.gray.dark.4)",
        },
      },
      950: {
        key: "{color.info.950}",
        $value: {
          light: "(palette.runtime.gray.dark.2)",
          dark: "(palette.runtime.gray.dark.2)",
        },
      },
      lightest: {
        key: "{color.info.lightest}",
        $value: {
          light: "(palette.runtime.gray.light.4)",
          dark: "(palette.runtime.gray.light.3)",
        },
      },
      light: {
        key: "{color.info.light}",
        $value: {
          light: "(palette.runtime.gray.light.8)",
          dark: "(palette.runtime.gray.light.7)",
        },
      },
      main: {
        key: "{color.info.main}",
        $value: {
          light: "(palette.runtime.gray.light.11)",
          dark: "(palette.runtime.gray.dark.11)",
        },
      },
      dark: {
        key: "{color.info.dark}",
        $value: {
          light: "(palette.runtime.gray.dark.7)",
          dark: "(palette.runtime.gray.dark.8)",
        },
      },
      darkest: {
        key: "{color.info.darkest}",
        $value: {
          light: "(palette.runtime.gray.dark.5)",
          dark: "(palette.runtime.gray.dark.6)",
        },
      },
      contrast: {
        key: "{color.info.contrast}",
        $value: {
          light: "(palette.runtime.gray.light.contrast)",
          dark: "(palette.runtime.gray.dark.contrast)",
        },
      },
      borderRegular: {
        key: "{color.info.borderRegular}",
        $value: {
          light: "(palette.runtime.gray.light.a7)",
          dark: "(palette.runtime.gray.dark.a7)",
        },
      },
      a11: {
        key: "{color.info.a11}",
        $value: {
          light: "(palette.runtime.gray.light.a11)",
          dark: "(palette.runtime.gray.dark.a11)",
        },
      },
      a1: {
        key: "{color.info.a1}",
        $value: {
          light: "(palette.runtime.gray.light.a1)",
          dark: "(palette.runtime.gray.dark.a1)",
        },
      },
      a9: {
        key: "{color.info.a9}",
        $value: {
          light: "(palette.runtime.gray.light.a9)",
          dark: "(palette.runtime.gray.dark.a9)",
        },
      },
      a12: {
        key: "{color.info.a12}",
        $value: {
          light: "(palette.runtime.gray.light.a12)",
          dark: "(palette.runtime.gray.dark.a12)",
        },
      },
      a8: {
        key: "{color.info.a8}",
        $value: {
          light: "(palette.runtime.gray.light.a8)",
          dark: "(palette.runtime.gray.dark.a8)",
        },
      },
      a5: {
        key: "{color.info.a5}",
        $value: {
          light: "(palette.runtime.gray.light.a5)",
          dark: "(palette.runtime.gray.dark.a5)",
        },
      },
      a4: {
        key: "{color.info.a4}",
        $value: {
          light: "(palette.runtime.gray.light.a4)",
          dark: "(palette.runtime.gray.dark.a4)",
        },
      },
      a2: {
        key: "{color.info.a2}",
        $value: {
          light: "(palette.runtime.gray.light.a2)",
          dark: "(palette.runtime.gray.dark.a2)",
        },
      },
      a7: {
        key: "{color.info.a7}",
        $value: {
          light: "(palette.runtime.gray.light.a7)",
          dark: "(palette.runtime.gray.dark.a7)",
        },
      },
      a6: {
        key: "{color.info.a6}",
        $value: {
          light: "(palette.runtime.gray.light.a6)",
          dark: "(palette.runtime.gray.dark.a6)",
        },
      },
      a10: {
        key: "{color.info.a10}",
        $value: {
          light: "(palette.runtime.gray.light.a10)",
          dark: "(palette.runtime.gray.dark.a10)",
        },
      },
      a3: {
        key: "{color.info.a3}",
        $value: {
          light: "(palette.runtime.gray.light.a3)",
          dark: "(palette.runtime.gray.dark.a3)",
        },
      },
      indicator: {
        key: "{color.info.indicator}",
        $value: {
          light: "(palette.runtime.gray.light.9)",
          dark: "(palette.runtime.gray.dark.9)",
        },
      },
      track: {
        key: "{color.info.track}",
        $value: {
          light: "(palette.runtime.gray.light.9)",
          dark: "(palette.runtime.gray.dark.9)",
        },
      },
      surface: {
        key: "{color.info.surface}",
        $value: {
          light: "(palette.runtime.gray.light.surface)",
          dark: "(palette.runtime.gray.dark.surface)",
        },
      },
      backgroundSubtle: {
        key: "{color.info.backgroundSubtle}",
        $value: {
          light: "(palette.runtime.gray.light.a2)",
          dark: "(palette.runtime.gray.dark.a2)",
        },
      },
      highContrast: {
        key: "{color.info.highContrast}",
        $value: {
          light: "(palette.runtime.gray.light.a12)",
          dark: "(palette.runtime.gray.dark.a12)",
        },
      },
      solidHover: {
        key: "{color.info.solidHover}",
        $value: {
          light: "(palette.runtime.gray.light.10)",
          dark: "(palette.runtime.gray.dark.10)",
        },
      },
      solid: {
        key: "{color.info.solid}",
        $value: {
          light: "(palette.runtime.gray.light.9)",
          dark: "(palette.runtime.gray.dark.9)",
        },
      },
      backgroundSoft: {
        key: "{color.info.backgroundSoft}",
        $value: {
          light: "(palette.runtime.gray.light.a3)",
          dark: "(palette.runtime.gray.dark.a3)",
        },
      },
      text: {
        key: "{color.info.text}",
        $value: {
          light: "(palette.runtime.gray.light.a11)",
          dark: "(palette.runtime.gray.dark.a11)",
        },
      },
      borderSubtle: {
        key: "{color.info.borderSubtle}",
        $value: {
          light: "(palette.runtime.gray.light.a6)",
          dark: "(palette.runtime.gray.dark.a6)",
        },
      },
      backgroundSubtlest: {
        key: "{color.info.backgroundSubtlest}",
        $value: {
          light: "(palette.runtime.gray.light.a1)",
          dark: "(palette.runtime.gray.dark.a1)",
        },
      },
      backgroundSoftHover: {
        key: "{color.info.backgroundSoftHover}",
        $value: {
          light: "(palette.runtime.gray.light.a4)",
          dark: "(palette.runtime.gray.dark.a4)",
        },
      },
      backgroundSoftActive: {
        key: "{color.info.backgroundSoftActive}",
        $value: {
          light: "(palette.runtime.gray.light.a5)",
          dark: "(palette.runtime.gray.dark.a5)",
        },
      },
      borderStrong: {
        key: "{color.info.borderStrong}",
        $value: {
          light: "(palette.runtime.gray.light.a8)",
          dark: "(palette.runtime.gray.dark.a8)",
        },
      },
      onHighContrast: {
        key: "{color.info.onHighContrast}",
        $value: {
          light: "(palette.runtime.gray.dark.12)",
          dark: "(palette.runtime.gray.light.12)",
        },
      },
      textAccessible: {
        key: "{color.info.textAccessible}",
        $value: {
          light: "(palette.runtime.gray.light.a11)",
          dark: "(palette.runtime.gray.dark.a11)",
        },
      },
    },
    neutral: {
      1: {
        key: "{color.neutral.1}",
        $value: {
          light: "(palette.runtime.gray.light.1)",
          dark: "(palette.runtime.gray.dark.1)",
        },
      },
      2: {
        key: "{color.neutral.2}",
        $value: {
          light: "(palette.runtime.gray.light.2)",
          dark: "(palette.runtime.gray.dark.2)",
        },
      },
      3: {
        key: "{color.neutral.3}",
        $value: {
          light: "(palette.runtime.gray.light.3)",
          dark: "(palette.runtime.gray.dark.3)",
        },
      },
      4: {
        key: "{color.neutral.4}",
        $value: {
          light: "(palette.runtime.gray.light.4)",
          dark: "(palette.runtime.gray.dark.4)",
        },
      },
      5: {
        key: "{color.neutral.5}",
        $value: {
          light: "(palette.runtime.gray.light.5)",
          dark: "(palette.runtime.gray.dark.5)",
        },
      },
      6: {
        key: "{color.neutral.6}",
        $value: {
          light: "(palette.runtime.gray.light.6)",
          dark: "(palette.runtime.gray.dark.6)",
        },
      },
      7: {
        key: "{color.neutral.7}",
        $value: {
          light: "(palette.runtime.gray.light.7)",
          dark: "(palette.runtime.gray.dark.7)",
        },
      },
      8: {
        key: "{color.neutral.8}",
        $value: {
          light: "(palette.runtime.gray.light.8)",
          dark: "(palette.runtime.gray.dark.8)",
        },
      },
      9: {
        key: "{color.neutral.9}",
        $value: {
          light: "(palette.runtime.gray.light.9)",
          dark: "(palette.runtime.gray.dark.9)",
        },
      },
      10: {
        key: "{color.neutral.10}",
        $value: {
          light: "(palette.runtime.gray.light.10)",
          dark: "(palette.runtime.gray.dark.10)",
        },
      },
      11: {
        key: "{color.neutral.11}",
        $value: {
          light: "(palette.runtime.gray.light.11)",
          dark: "(palette.runtime.gray.dark.11)",
        },
      },
      12: {
        key: "{color.neutral.12}",
        $value: {
          light: "(palette.runtime.gray.light.12)",
          dark: "(palette.runtime.gray.dark.12)",
        },
      },
      50: {
        key: "{color.neutral.50}",
        $value: {
          light: "(palette.runtime.gray.light.2)",
          dark: "(palette.runtime.gray.light.2)",
        },
      },
      100: {
        key: "{color.neutral.100}",
        $value: {
          light: "(palette.runtime.gray.light.3)",
          dark: "(palette.runtime.gray.light.3)",
        },
      },
      200: {
        key: "{color.neutral.200}",
        $value: {
          light: "(palette.runtime.gray.light.5)",
          dark: "(palette.runtime.gray.light.5)",
        },
      },
      300: {
        key: "{color.neutral.300}",
        $value: {
          light: "(palette.runtime.gray.light.8)",
          dark: "(palette.runtime.gray.light.8)",
        },
      },
      400: {
        key: "{color.neutral.400}",
        $value: {
          light: "(palette.runtime.gray.light.9)",
          dark: "(palette.runtime.gray.light.9)",
        },
      },
      500: {
        key: "{color.neutral.500}",
        $value: {
          light: "(palette.runtime.gray.light.11)",
          dark: "(palette.runtime.gray.light.11)",
        },
      },
      600: {
        key: "{color.neutral.600}",
        $value: {
          light: "(palette.runtime.gray.dark.7)",
          dark: "(palette.runtime.gray.dark.7)",
        },
      },
      700: {
        key: "{color.neutral.700}",
        $value: {
          light: "(palette.runtime.gray.dark.6)",
          dark: "(palette.runtime.gray.dark.6)",
        },
      },
      800: {
        key: "{color.neutral.800}",
        $value: {
          light: "(palette.runtime.gray.dark.5)",
          dark: "(palette.runtime.gray.dark.5)",
        },
      },
      900: {
        key: "{color.neutral.900}",
        $value: {
          light: "(palette.runtime.gray.dark.4)",
          dark: "(palette.runtime.gray.dark.4)",
        },
      },
      950: {
        key: "{color.neutral.950}",
        $value: {
          light: "(palette.runtime.gray.dark.3)",
          dark: "(palette.runtime.gray.dark.3)",
        },
      },
      a2: {
        key: "{color.neutral.a2}",
        $value: {
          light: "(palette.runtime.gray.light.a2)",
          dark: "(palette.runtime.gray.dark.a2)",
        },
      },
      a1: {
        key: "{color.neutral.a1}",
        $value: {
          light: "(palette.runtime.gray.light.a1)",
          dark: "(palette.runtime.gray.dark.a1)",
        },
      },
      a11: {
        key: "{color.neutral.a11}",
        $value: {
          light: "(palette.runtime.gray.light.a11)",
          dark: "(palette.runtime.gray.dark.a11)",
        },
      },
      a8: {
        key: "{color.neutral.a8}",
        $value: {
          light: "(palette.runtime.gray.light.a8)",
          dark: "(palette.runtime.gray.dark.a8)",
        },
      },
      a12: {
        key: "{color.neutral.a12}",
        $value: {
          light: "(palette.runtime.gray.light.a12)",
          dark: "(palette.runtime.gray.dark.a12)",
        },
      },
      a9: {
        key: "{color.neutral.a9}",
        $value: {
          light: "(palette.runtime.gray.light.a9)",
          dark: "(palette.runtime.gray.dark.a9)",
        },
      },
      a5: {
        key: "{color.neutral.a5}",
        $value: {
          light: "(palette.runtime.gray.light.a5)",
          dark: "(palette.runtime.gray.dark.a5)",
        },
      },
      a4: {
        key: "{color.neutral.a4}",
        $value: {
          light: "(palette.runtime.gray.light.a4)",
          dark: "(palette.runtime.gray.dark.a4)",
        },
      },
      a3: {
        key: "{color.neutral.a3}",
        $value: {
          light: "(palette.runtime.gray.light.a3)",
          dark: "(palette.runtime.gray.dark.a3)",
        },
      },
      a7: {
        key: "{color.neutral.a7}",
        $value: {
          light: "(palette.runtime.gray.light.a7)",
          dark: "(palette.runtime.gray.dark.a7)",
        },
      },
      a6: {
        key: "{color.neutral.a6}",
        $value: {
          light: "(palette.runtime.gray.light.a6)",
          dark: "(palette.runtime.gray.dark.a6)",
        },
      },
      a10: {
        key: "{color.neutral.a10}",
        $value: {
          light: "(palette.runtime.gray.light.a10)",
          dark: "(palette.runtime.gray.dark.a10)",
        },
      },
      track: {
        key: "{color.neutral.track}",
        $value: {
          light: "(palette.runtime.gray.light.9)",
          dark: "(palette.runtime.gray.dark.9)",
        },
      },
      indicator: {
        key: "{color.neutral.indicator}",
        $value: {
          light: "(palette.runtime.gray.light.9)",
          dark: "(palette.runtime.gray.dark.9)",
        },
      },
      surface: {
        key: "{color.neutral.surface}",
        $value: {
          light: "(palette.runtime.gray.light.surface)",
          dark: "(palette.runtime.gray.dark.surface)",
        },
      },
      contrast: {
        key: "{color.neutral.contrast}",
        $value: {
          light: "(palette.runtime.gray.light.contrast)",
          dark: "(palette.runtime.gray.dark.contrast)",
        },
      },
      backgroundSubtle: {
        key: "{color.neutral.backgroundSubtle}",
        $value: {
          light: "(palette.runtime.gray.light.a2)",
          dark: "(palette.runtime.gray.dark.a2)",
        },
      },
      highContrast: {
        key: "{color.neutral.highContrast}",
        $value: {
          light: "(palette.runtime.gray.light.a12)",
          dark: "(palette.runtime.gray.dark.a12)",
        },
      },
      text: {
        key: "{color.neutral.text}",
        $value: {
          light: "(palette.runtime.gray.light.a11)",
          dark: "(palette.runtime.gray.dark.a11)",
        },
      },
      solid: {
        key: "{color.neutral.solid}",
        $value: {
          light: "(palette.runtime.gray.light.9)",
          dark: "(palette.runtime.gray.dark.9)",
        },
      },
      backgroundSoft: {
        key: "{color.neutral.backgroundSoft}",
        $value: {
          light: "(palette.runtime.gray.light.a3)",
          dark: "(palette.runtime.gray.dark.a3)",
        },
      },
      solidHover: {
        key: "{color.neutral.solidHover}",
        $value: {
          light: "(palette.runtime.gray.light.10)",
          dark: "(palette.runtime.gray.dark.10)",
        },
      },
      borderSubtle: {
        key: "{color.neutral.borderSubtle}",
        $value: {
          light: "(palette.runtime.gray.light.a6)",
          dark: "(palette.runtime.gray.dark.a6)",
        },
      },
      borderRegular: {
        key: "{color.neutral.borderRegular}",
        $value: {
          light: "(palette.runtime.gray.light.a7)",
          dark: "(palette.runtime.gray.dark.a7)",
        },
      },
      main: {
        key: "{color.neutral.main}",
        $value: {
          light: "(palette.runtime.gray.light.11)",
          dark: "(palette.runtime.gray.dark.11)",
        },
      },
      dark: {
        key: "{color.neutral.dark}",
        $value: {
          light: "(palette.runtime.gray.dark.7)",
          dark: "(palette.runtime.gray.dark.8)",
        },
      },
      light: {
        key: "{color.neutral.light}",
        $value: {
          light: "(palette.runtime.gray.light.8)",
          dark: "(palette.runtime.gray.light.7)",
        },
      },
      darkest: {
        key: "{color.neutral.darkest}",
        $value: {
          light: "(palette.runtime.gray.dark.5)",
          dark: "(palette.runtime.gray.dark.6)",
        },
      },
      lightest: {
        key: "{color.neutral.lightest}",
        $value: {
          light: "(palette.runtime.gray.light.4)",
          dark: "(palette.runtime.gray.light.3)",
        },
      },
      backgroundSubtlest: {
        key: "{color.neutral.backgroundSubtlest}",
        $value: {
          light: "(palette.runtime.gray.light.a1)",
          dark: "(palette.runtime.gray.dark.a1)",
        },
      },
      backgroundSoftHover: {
        key: "{color.neutral.backgroundSoftHover}",
        $value: {
          light: "(palette.runtime.gray.light.a4)",
          dark: "(palette.runtime.gray.dark.a4)",
        },
      },
      backgroundSoftActive: {
        key: "{color.neutral.backgroundSoftActive}",
        $value: {
          light: "(palette.runtime.gray.light.a5)",
          dark: "(palette.runtime.gray.dark.a5)",
        },
      },
      borderStrong: {
        key: "{color.neutral.borderStrong}",
        $value: {
          light: "(palette.runtime.gray.light.a8)",
          dark: "(palette.runtime.gray.dark.a8)",
        },
      },
      onHighContrast: {
        key: "{color.neutral.onHighContrast}",
        $value: {
          light: "(palette.runtime.gray.dark.12)",
          dark: "(palette.runtime.gray.light.12)",
        },
      },
      textAccessible: {
        key: "{color.neutral.textAccessible}",
        $value: {
          light: "(palette.runtime.gray.light.a11)",
          dark: "(palette.runtime.gray.dark.a11)",
        },
      },
    },
    darkToLight: {
      key: "{color.darkToLight}",
      $value: {
        light: "(palette.runtime.gray.light.12)",
        dark: "#ffffff",
      },
    },
  },
  palette: {
    runtime: {
      accent: {
        light: {
          1: {
            key: "{palette.runtime.accent.light.1}",
            $value: "#fdfdff",
          },
          2: {
            key: "{palette.runtime.accent.light.2}",
            $value: "#f8f8ff",
          },
          3: {
            key: "{palette.runtime.accent.light.3}",
            $value: "#f0f1ff",
          },
          4: {
            key: "{palette.runtime.accent.light.4}",
            $value: "#e5e6ff",
          },
          5: {
            key: "{palette.runtime.accent.light.5}",
            $value: "#d9dbff",
          },
          6: {
            key: "{palette.runtime.accent.light.6}",
            $value: "#caccff",
          },
          7: {
            key: "{palette.runtime.accent.light.7}",
            $value: "#b6b7ff",
          },
          8: {
            key: "{palette.runtime.accent.light.8}",
            $value: "#9c99ff",
          },
          9: {
            key: "{palette.runtime.accent.light.9}",
            $value: "#7560ff",
          },
          10: {
            key: "{palette.runtime.accent.light.10}",
            $value: "#6a51f0",
          },
          11: {
            key: "{palette.runtime.accent.light.11}",
            $value: "#5d47d7",
          },
          12: {
            key: "{palette.runtime.accent.light.12}",
            $value: "#2c226c",
          },
          a11: {
            key: "{palette.runtime.accent.light.a11}",
            $value: "#1f00c8b8",
          },
          a12: {
            key: "{palette.runtime.accent.light.a12}",
            $value: "#0c0055de",
          },
          a9: {
            key: "{palette.runtime.accent.light.a9}",
            $value: "#2200ff9e",
          },
          a8: {
            key: "{palette.runtime.accent.light.a8}",
            $value: "#0800ff66",
          },
          surface: {
            key: "{palette.runtime.accent.light.surface}",
            $value: "#f6f6ffcc",
          },
          a2: {
            key: "{palette.runtime.accent.light.a2}",
            $value: "#0000ff08",
          },
          a10: {
            key: "{palette.runtime.accent.light.a10}",
            $value: "#2500e9ad",
          },
          a7: {
            key: "{palette.runtime.accent.light.a7}",
            $value: "#0004ff4a",
          },
          a6: {
            key: "{palette.runtime.accent.light.a6}",
            $value: "#000aff36",
          },
          contrast: {
            key: "{palette.runtime.accent.light.contrast}",
            $value: "#ffffff",
          },
          a4: {
            key: "{palette.runtime.accent.light.a4}",
            $value: "#000aff1a",
          },
          a3: {
            key: "{palette.runtime.accent.light.a3}",
            $value: "#0011ff0f",
          },
          a5: {
            key: "{palette.runtime.accent.light.a5}",
            $value: "#000eff26",
          },
          a1: {
            key: "{palette.runtime.accent.light.a1}",
            $value: "#0000ff03",
          },
        },
        dark: {
          1: {
            key: "{palette.runtime.accent.dark.1}",
            $value: "#080815",
          },
          2: {
            key: "{palette.runtime.accent.dark.2}",
            $value: "#141327",
          },
          3: {
            key: "{palette.runtime.accent.dark.3}",
            $value: "#221d50",
          },
          4: {
            key: "{palette.runtime.accent.dark.4}",
            $value: "#2d2072",
          },
          5: {
            key: "{palette.runtime.accent.dark.5}",
            $value: "#372983",
          },
          6: {
            key: "{palette.runtime.accent.dark.6}",
            $value: "#413592",
          },
          7: {
            key: "{palette.runtime.accent.dark.7}",
            $value: "#4d41a7",
          },
          8: {
            key: "{palette.runtime.accent.dark.8}",
            $value: "#5c4ec7",
          },
          9: {
            key: "{palette.runtime.accent.dark.9}",
            $value: "#7560ff",
          },
          10: {
            key: "{palette.runtime.accent.dark.10}",
            $value: "#6a51f0",
          },
          11: {
            key: "{palette.runtime.accent.dark.11}",
            $value: "#aaa9ff",
          },
          12: {
            key: "{palette.runtime.accent.dark.12}",
            $value: "#dddfff",
          },
          a10: {
            key: "{palette.runtime.accent.dark.a10}",
            $value: "#7055fef0",
          },
          contrast: {
            key: "{palette.runtime.accent.dark.contrast}",
            $value: "#ffffff",
          },
          a11: {
            key: "{palette.runtime.accent.dark.a11}",
            $value: "#aaa9ff",
          },
          a9: {
            key: "{palette.runtime.accent.dark.a9}",
            $value: "#7560ff",
          },
          a7: {
            key: "{palette.runtime.accent.dark.a7}",
            $value: "#735ffea3",
          },
          a8: {
            key: "{palette.runtime.accent.dark.a8}",
            $value: "#7563fec4",
          },
          a5: {
            key: "{palette.runtime.accent.dark.a5}",
            $value: "#6649fd7d",
          },
          a12: {
            key: "{palette.runtime.accent.dark.a12}",
            $value: "#dddfff",
          },
          a1: {
            key: "{palette.runtime.accent.dark.a1}",
            $value: "#0000f30a",
          },
          a2: {
            key: "{palette.runtime.accent.dark.a2}",
            $value: "#6757fa1f",
          },
          a6: {
            key: "{palette.runtime.accent.dark.a6}",
            $value: "#6e58fe8f",
          },
          a3: {
            key: "{palette.runtime.accent.dark.a3}",
            $value: "#614dfd4a",
          },
          surface: {
            key: "{palette.runtime.accent.dark.surface}",
            $value: "#1f1c4380",
          },
          a4: {
            key: "{palette.runtime.accent.dark.a4}",
            $value: "#5e3eff6b",
          },
        },
      },
      gray: {
        light: {
          1: {
            key: "{palette.runtime.gray.light.1}",
            $value: "#fcfcfd",
          },
          2: {
            key: "{palette.runtime.gray.light.2}",
            $value: "#f8f9fa",
          },
          3: {
            key: "{palette.runtime.gray.light.3}",
            $value: "#eff0f2",
          },
          4: {
            key: "{palette.runtime.gray.light.4}",
            $value: "#e7e8ea",
          },
          5: {
            key: "{palette.runtime.gray.light.5}",
            $value: "#dfe1e3",
          },
          6: {
            key: "{palette.runtime.gray.light.6}",
            $value: "#d8dadd",
          },
          7: {
            key: "{palette.runtime.gray.light.7}",
            $value: "#cccfd2",
          },
          8: {
            key: "{palette.runtime.gray.light.8}",
            $value: "#b8bcc0",
          },
          9: {
            key: "{palette.runtime.gray.light.9}",
            $value: "#8a8e92",
          },
          10: {
            key: "{palette.runtime.gray.light.10}",
            $value: "#808487",
          },
          11: {
            key: "{palette.runtime.gray.light.11}",
            $value: "#616467",
          },
          12: {
            key: "{palette.runtime.gray.light.12}",
            $value: "#1e2022",
          },
          contrast: {
            key: "{palette.runtime.gray.light.contrast}",
            $value: "#ffffff",
          },
          a10: {
            key: "{palette.runtime.gray.light.a10}",
            $value: "#00090f80",
          },
          a7: {
            key: "{palette.runtime.gray.light.a7}",
            $value: "#000f1e33",
          },
          a6: {
            key: "{palette.runtime.gray.light.a6}",
            $value: "#000e2126",
          },
          a5: {
            key: "{palette.runtime.gray.light.a5}",
            $value: "#00102021",
          },
          a4: {
            key: "{palette.runtime.gray.light.a4}",
            $value: "#000b2017",
          },
          a3: {
            key: "{palette.runtime.gray.light.a3}",
            $value: "#0010300f",
          },
          a2: {
            key: "{palette.runtime.gray.light.a2}",
            $value: "#00254908",
          },
          a1: {
            key: "{palette.runtime.gray.light.a1}",
            $value: "#00005503",
          },
          a9: {
            key: "{palette.runtime.gray.light.a9}",
            $value: "#00091275",
          },
          a11: {
            key: "{palette.runtime.gray.light.a11}",
            $value: "#00050a9e",
          },
          surface: {
            key: "{palette.runtime.gray.light.surface}",
            $value: "#ffffffcc",
          },
          a12: {
            key: "{palette.runtime.gray.light.a12}",
            $value: "#000205e0",
          },
          a8: {
            key: "{palette.runtime.gray.light.a8}",
            $value: "#000f1d47",
          },
        },
        dark: {
          1: {
            key: "{palette.runtime.gray.dark.1}",
            $value: "#090a0b",
          },
          2: {
            key: "{palette.runtime.gray.dark.2}",
            $value: "#161718",
          },
          3: {
            key: "{palette.runtime.gray.dark.3}",
            $value: "#202223",
          },
          4: {
            key: "{palette.runtime.gray.dark.4}",
            $value: "#27292b",
          },
          5: {
            key: "{palette.runtime.gray.dark.5}",
            $value: "#2f3132",
          },
          6: {
            key: "{palette.runtime.gray.dark.6}",
            $value: "#373a3c",
          },
          7: {
            key: "{palette.runtime.gray.dark.7}",
            $value: "#45484b",
          },
          8: {
            key: "{palette.runtime.gray.dark.8}",
            $value: "#5c6165",
          },
          9: {
            key: "{palette.runtime.gray.dark.9}",
            $value: "#686e73",
          },
          10: {
            key: "{palette.runtime.gray.dark.10}",
            $value: "#757b81",
          },
          11: {
            key: "{palette.runtime.gray.dark.11}",
            $value: "#b0b4b8",
          },
          12: {
            key: "{palette.runtime.gray.dark.12}",
            $value: "#edeeef",
          },
          surface: {
            key: "{palette.runtime.gray.dark.surface}",
            $value: "#00000000",
          },
          a10: {
            key: "{palette.runtime.gray.dark.a10}",
            $value: "#e7f3fd7d",
          },
          a9: {
            key: "{palette.runtime.gray.dark.a9}",
            $value: "#e8f4ff6e",
          },
          a6: {
            key: "{palette.runtime.gray.dark.a6}",
            $value: "#ebf6fc33",
          },
          a4: {
            key: "{palette.runtime.gray.dark.a4}",
            $value: "#eaf3fb21",
          },
          a3: {
            key: "{palette.runtime.gray.dark.a3}",
            $value: "#ebf6f71a",
          },
          a2: {
            key: "{palette.runtime.gray.dark.a2}",
            $value: "#f5f7f80d",
          },
          a1: {
            key: "{palette.runtime.gray.dark.a1}",
            $value: "#00000000",
          },
          a11: {
            key: "{palette.runtime.gray.dark.a11}",
            $value: "#f4faffb5",
          },
          a7: {
            key: "{palette.runtime.gray.dark.a7}",
            $value: "#edf6ff42",
          },
          a8: {
            key: "{palette.runtime.gray.dark.a8}",
            $value: "#e8f4fd5e",
          },
          a12: {
            key: "{palette.runtime.gray.dark.a12}",
            $value: "#fcfdfef0",
          },
          contrast: {
            key: "{palette.runtime.gray.dark.contrast}",
            $value: "#ffffff",
          },
          a5: {
            key: "{palette.runtime.gray.dark.a5}",
            $value: "#f5fdfe29",
          },
        },
      },
    },
  },
};
